var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNonBankAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 6,
    fill: "#DEFFED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 33.4112C36.7551 33.4112 38.1778 31.9885 38.1778 30.2334C38.1778 28.4784 36.7551 27.0557 35 27.0557C33.245 27.0557 31.8223 28.4784 31.8223 30.2334C31.8223 31.9885 33.245 33.4112 35 33.4112Z",
    fill: "#072A30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0779 41.6666V42.6222H29.9224V41.6666C29.9248 41.3307 30.056 41.0086 30.289 40.7666C30.4072 40.6488 30.5476 40.5557 30.7021 40.4927C30.8566 40.4297 31.0222 40.3982 31.189 40.4H38.8113C39.1478 40.3989 39.4713 40.5306 39.7113 40.7666C39.9442 41.0086 40.0755 41.3307 40.0779 41.6666Z",
    fill: "#072A30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9668 21.7888C44.2706 21.7901 42.6012 21.3661 41.1112 20.5555L35.0001 17.2222L28.889 20.5555C27.3991 21.3661 25.7296 21.7901 24.0335 21.7888H19.5112V35.8888C19.5114 38.8069 20.349 41.6635 21.9247 44.1196C23.5003 46.5756 25.7478 48.5278 28.4001 49.7444L35.0001 52.7777L41.6668 49.7444C44.3191 48.5278 46.5666 46.5756 48.1422 44.1196C49.7179 41.6635 50.5555 38.8069 50.5557 35.8888V21.7888H45.9668ZM35.0001 24.5222C36.1297 24.5222 37.2339 24.8571 38.173 25.4847C39.1122 26.1122 39.8442 27.0042 40.2765 28.0477C40.7088 29.0913 40.8219 30.2396 40.6015 31.3475C40.3811 32.4553 39.8372 33.4729 39.0385 34.2716C38.2398 35.0704 37.2221 35.6143 36.1143 35.8347C35.0065 36.055 33.8581 35.9419 32.8146 35.5097C31.771 35.0774 30.8791 34.3454 30.2515 33.4062C29.624 32.467 29.289 31.3628 29.289 30.2333C29.2919 28.7195 29.8946 27.2686 30.965 26.1982C32.0354 25.1278 33.4863 24.5251 35.0001 24.5222ZM42.6223 43.8888C42.6194 44.2239 42.4851 44.5444 42.2481 44.7813C42.0112 45.0182 41.6907 45.1526 41.3557 45.1555H28.6557C28.3187 45.1555 27.9954 45.0224 27.7561 44.7852C27.5167 44.548 27.3808 44.2258 27.3779 43.8888V41.6666C27.3779 40.6558 27.7794 39.6865 28.4941 38.9718C29.2089 38.257 30.1782 37.8555 31.189 37.8555H38.8112C39.822 37.8555 40.7914 38.257 41.5061 38.9718C42.2208 39.6865 42.6223 40.6558 42.6223 41.6666V43.8888Z",
    fill: "#43D685"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonBankAdmin);
export default __webpack_public_path__ + "static/media/NonBankAdmin.525cbc08a8f71cf3eed5336690e0c02f.svg";
export { ForwardRef as ReactComponent };